export const registerBtnEnable = {
	init: function(registerContainer) {
		if (!registerContainer) return;
		this.checkbox = registerContainer.querySelector('input[type="checkbox"]');
		if (!this.checkbox) return;
		this.submitBtn = registerContainer.querySelector('.basket-summary__continue-btn');
		this.assignListener();
	},

	assignListener: function() {
		this.checkbox.addEventListener('input', e=> {
			if ((this.checkbox).checked) {
				this.submitBtn.removeAttribute("disabled");
			} else {
				this.submitBtn.setAttribute("disabled", true);
			}
		})
	}
}
